/*
 * Fischer Price CMS: Just some basic formatting rules to get a few of our regions to display more naturally
 */

import { RegionInfoFragment } from 'utils/gqlReactTypings.generated.d';

interface RegionGrammar {
  // For example: 'The Bay Area' uses an article, but 'The New York City' would look wrong
  needsArticle?: boolean;
  useNear?: boolean;
  displayNameOverride?: string;
}

export const RegionGrammarRules: Record<string, RegionGrammar> = {
  ATLANTA: {},
  AUSTIN: {},
  BAY_AREA: { needsArticle: true },
  BOSTON: {},
  CHICAGO: {},
  DALLAS: {},
  DC_AREA: { needsArticle: true },
  HOUSTON: {},
  LOS_ANGELES: {},
  NASSAU: {},
  NEW_JERSEY: {},
  NEW_YORK: { useNear: true },
  OTHER: {},
  SEATTLE: {},
};

export const getRegionDisplayName = (region: Pick<RegionInfoFragment, 'name' | 'displayName'>): string => {
  const regionGrammar: RegionGrammar = RegionGrammarRules[region.name];
  return `${regionGrammar?.needsArticle ? 'The ' : ''}${
    regionGrammar?.displayNameOverride ?? region.displayName.replace('the', '')
  }`;
};
